const routes = {
  '/app/team-account-setup': {
    fetch: () =>
      import(
        /* webpackChunkName: 'team-account-route' */ 'app/team-account/asyncRoute'
      ).then(module => module.default),
  },
};

export default routes;
